import { FC } from "react";
import { Button, IconButton, Modal, SvgIcon } from "@mui/material";

import "./style.scss";
import { ReactComponent as CloseIcon } from "../../assets/crossIcon.svg";

export enum ConfirmationPopupType {
    default,
    dangerous
}

const ConfirmationPopup = ({
    open,
    type = ConfirmationPopupType.default,
    icon,
    title,
    subtitle,
    description,
    actionName,
    showCancelButton = false,
    handleAction,
    handleClose
}: {
    open: boolean;
    type?: ConfirmationPopupType;
    icon?: FC<React.SVGProps<SVGSVGElement>>;
    title: string;
    subtitle?: string;
    description: string;
    actionName: string;
    showCancelButton?: boolean;
    handleAction: () => void;
    handleClose: () => void;
}) => {
    return (
        <Modal
            style={{ display: "flex" }}
            className="confirmation-area"
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div
                className={`confirmation-window${type === ConfirmationPopupType.dangerous ? " confirmation-window--dangerous" : ""}`}
            >
                <IconButton className="confirmation-window__button-close" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <div className="confirmation-window-title">
                    {icon && (
                        <SvgIcon
                            className="confirmation-window-title__icon"
                            component={icon}
                            inheritViewBox
                        />
                    )}
                    <span
                        className="confirmation-window-title__text"
                        style={{ marginLeft: icon ? 16 : 0 }}
                    >
                        {title}
                    </span>
                </div>
                {subtitle && <div className="confirmation-window-subtitle">{subtitle}</div>}
                <div className="confirmation-window-description">{description}</div>
                <div className="confirmation-window-actions">
                    {showCancelButton && (
                        <Button className="secondary-button" variant="text" onClick={handleClose}>
                            Cancel
                        </Button>
                    )}
                    <Button
                        className={`primary-button${showCancelButton ? " confirmation-window-actions-button-margin" : ""}`}
                        variant="text"
                        onClick={handleAction}
                    >
                        {actionName}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmationPopup;
